<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_calendar"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Opening hour <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-select label="Succursale" multiple="false" v-model="resource.branch" :default="resource.branch_id" id="id" :options="branches" v-if="branches" :required="true"></form-select>

                                <form-checklist label="Jours de la semaine"
                                                v-if="days_week"
                                                v-model="resource.days_week"
                                                :options="days_week"
                                                multiple="true"
                                                name="name"
                                                :required="true"></form-checklist>

                                <group-line-2>
                                  <form-time label="Heure d'ouverture" v-model="resource.start_hour" format="HH:mm" :required="true"></form-time>
                                  <form-time label="Heure de fermeture" v-model="resource.end_hour" format="HH:mm" :required="true"></form-time>
                                </group-line-2>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import {constants} from '../../../const.js'
    import BranchService from '../branch/BranchService.js';
    import ScopeOpeningHour from './ScopeOpeningHourService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                day_week_id: 0,
                branchService: null,
                days_week: constants.days_week,
                branches: []
            }
        },
        mounted: function(){
            BranchService.query().then(response => {
                this.branches = response.data.data
                this.isLoading = false
            })
        },
        methods:{
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.resource.days_week = [];
                this.days_week.forEach((day, index) => {
                    if(this.resource[day.id]){
                        this.resource.days_week.push({
                            id: day.id,
                            name: day.name
                        });
                    }
                });

                this.initialize()

                console.log('Days week retuned: ',this.resource.days_week);
                console.log('Branch: ',this.resource.branch);
            },
            getResource: function(){
                return ScopeOpeningHour
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/opening-hours/Edit.vue